import { EXPERIENCE_DOMAIN_CONFIG, EXPERIENCE_HOST_DOMAINS } from '../constants';

type CustomTrackingConfig = {
  [key in EXPERIENCE_DOMAIN_CONFIG]?: {
    companyIds: number[];
  };
};

export const customTrackingConfig: CustomTrackingConfig = {
  [EXPERIENCE_HOST_DOMAINS.localhost]: {
    companyIds: [1],
  },
  [EXPERIENCE_HOST_DOMAINS.mumbai]: {
    companyIds: [1],
  },
  [EXPERIENCE_HOST_DOMAINS.qa1]: {
    companyIds: [3024912],
  },
  [EXPERIENCE_HOST_DOMAINS.eu]: {
    companyIds: [1002515],
  },
};

export const customRedirectionConfig: CustomTrackingConfig = {
  [EXPERIENCE_HOST_DOMAINS.uatEU]: {
    companyIds: [113624, 417, 4863],
  },
  [EXPERIENCE_HOST_DOMAINS.uatAM]: {
    companyIds: [27269, 27301],
  },
  [EXPERIENCE_HOST_DOMAINS.uatAMTCPlus]: {
    companyIds: [27269, 27301],
  },
  [EXPERIENCE_HOST_DOMAINS.us]: {
    companyIds: [14334],
  },
  [EXPERIENCE_HOST_DOMAINS.us1]: {
    companyIds: [43279],
  },
  [EXPERIENCE_HOST_DOMAINS.usTCPlus]: {
    companyIds: [43279],
  },
};
